import { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.target);
    const subject = `[lakeshore] ${data.get('inquiry')} — ${data.get('name')}`;
    const body = `${data.get('message')}\n\n— ${data.get('name')}\n${data.get('email')}`;
    window.location.href = `mailto:abhi@lakeshore.studio?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSubmitted(true);
  }

  return (
    <>
      <section className="page-header">
        <div className="page-label">Contact</div>
        <h1 className="page-title">Tell us what's broken.</h1>
      </section>

      <section className="contact-body">
        <div className="contact-left">
          <div className="section-label">Get In Touch</div>

          {!submitted ? (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Name</label>
                <input type="text" name="name" className="form-input" placeholder="Your name" required />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input type="email" name="email" className="form-input" placeholder="you@company.com" required />
              </div>
              <div className="form-group">
                <label className="form-label">Inquiry Type</label>
                <select name="inquiry" className="form-select" required defaultValue="">
                  <option value="" disabled>Select one</option>
                  <option>I have a problem worth solving</option>
                  <option>Partnership or collaboration</option>
                  <option>Investment inquiry</option>
                  <option>Press or media</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea name="message" className="form-input" placeholder="Tell us what you're thinking..." required />
              </div>
              <button type="submit" className="submit-btn">SEND MESSAGE →</button>
            </form>
          ) : (
            <div className="form-success show">
              <div className="success-heading">Almost there.</div>
              <div className="success-body">Your email draft just opened — hit send and we'll get back to you within 48 hours. If it didn't open, write us directly at <a href="mailto:abhi@lakeshore.studio">abhi@lakeshore.studio</a>.</div>
            </div>
          )}
        </div>

        <div className="contact-right">
          <div className="section-label">Details</div>

          <div className="info-block">
            <div className="info-label">Location</div>
            <div className="info-value">Los Angeles, CA</div>
          </div>
          <div className="info-block">
            <div className="info-label">Email</div>
            <div className="info-value"><a href="mailto:abhi@lakeshore.studio">abhi@lakeshore.studio</a></div>
          </div>
          <div className="info-block">
            <div className="info-label">Response Time</div>
            <div className="info-value">We respond to all inquiries within 48 hours.</div>
          </div>

          <div className="inquiry-grid">
            <div className="inquiry-card">
              <div className="iq-title">Build With Us</div>
              <div className="iq-desc">You live a broken workflow and want it turned into a product.</div>
            </div>
            <div className="inquiry-card">
              <div className="iq-title">Partner With Us</div>
              <div className="iq-desc">You have infrastructure, reach, or domain expertise to offer.</div>
            </div>
            <div className="inquiry-card">
              <div className="iq-title">Invest</div>
              <div className="iq-desc">You're interested in investing in lakeshore or one of our ventures.</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
